import { Box, Flex, GridItem, Heading, Stack, Text } from "@chakra-ui/react";
import React, { useState } from "react";

const ProjectItem = ({ item }) => {
    const [onHover, setOnHover] = useState(false);
    return (
        <GridItem>
            <Box borderRadius="10px" bg="secondary.1" p="3" onMouseEnter={() => setOnHover(true)} onMouseLeave={() => setOnHover(false)}>
                <Stack
                    borderRadius="10px"
                    h="270px"
                    bg="secondary.2"
                    bgImg={item.img}
                    bgSize="cover"
                    bgPos="center"
                    justifyContent="space-between"
                    pos="relative"
                    overflow="hidden"
                >
                    {onHover && (
                        <>
                            <Box
                                pos="absolute"
                                left="50%"
                                top="50%"
                                transform="translate(-50%, -50%)"
                                w="105%"
                                h="105%"
                                bgImg={item.img}
                                bgSize="cover"
                                bgPos="center"
                                filter='auto'
                                blur='2px'
                                _after={{
                                    content: "''",
                                    bg: "black",
                                    w: "100%",
                                    h: "100%",
                                    opacity: 0.7,
                                    pos: "absolute",
                                    top: 0,
                                    left: 0,
                                    display: 'block'
                                }}
                            ></Box>
                            <Stack p={3} zIndex={10} h="100%" justifyContent="space-between">
                                <Text color="white" maxH="240px">{item.description}</Text>
                                <Flex gap="0.3rem">
                                    {item.tags.map(tag => (
                                        <Box
                                            display="inline-block"
                                            textTransform="uppercase"
                                            border="1px solid"
                                            borderColor="gray.500"
                                            pos="relative"
                                            py={1} px={2}
                                            borderRadius="20px"
                                            boxSizing="content-box"
                                            overflow="hidden"
                                            _after={{
                                                pos: 'absolute',
                                                content: "''",
                                                display: "block",
                                                bg: "gray.500",
                                                h: '100%',
                                                w: '100%',
                                                opacity: "50%",
                                                top: 0,
                                                left: 0
                                            }}
                                        >
                                            <Text zIndex={10} pos="relative" color="white" fontSize={['xs', 'sm']}>{tag}</Text>
                                        </Box>
                                    ))}
                                </Flex>
                            </Stack>
                        </>
                    )}
                </Stack>
                <Box mt="2">
                    <Text color="white" fontSize="sm">{item.when}</Text>
                    <Heading as="h3" color="white" fontSize={['md', 'lg']}>{item.title}</Heading>
                </Box>
            </Box>
        </GridItem>
    );
};

export default ProjectItem;